import { toFinite, toString, isNil } from 'lodash/fp'
import React, { useState, useEffect } from 'react'
import NumberInput from 'react-number-format'
import { Input } from 'reactstrap'
import { Flex } from 'rebass'

export const onKeyDown = ({ setDirty }) => (event) => {
  const nextValue = event.target.value.substring(1)
  const isBackSpace = event.keyCode === 8
  const isDeleteFirstDigit = event.target.selectionStart === 1
  const isNotEmpty = !isNil(event.target.value) && nextValue !== ''
  const isDeletingFrontOfComma = !/[1-9.]/.test(event.target.value.substring(1, 2))
  const isNextValueIsNotZero = !(nextValue.startsWith('0.') || nextValue === '0')

  if (isBackSpace && isDeleteFirstDigit && isNotEmpty && isDeletingFrontOfComma && isNextValueIsNotZero) {
    event.preventDefault()
    setDirty(true)
  }
}

export const Component = NumberInput

function MyComponent({
  type = 'tel',
  setValue,
  allowNegative = false,
  customInput = Input,
  pattern = '[0-9]*',
  readOnly,
  displayType,
  allow,
  thousandSeparator,
  validate,
  isNumber = false,
  children,
  footer,
  ...rest
}) {
  const actualValue = rest.value ? rest.value : rest.actualValue
  const value = displayType === 'text' ? toFinite(actualValue) || '-' : actualValue
  const format = thousandSeparator
    ? undefined
    : rest.format ||
      function(value) {
        return value
      }
  const isAllowed = ({ value }) => (allow ? allow(value) : true)
  const style = { pointerEvents: readOnly ? 'none' : undefined }

  const [isDirty, setDirty] = useState(false)

  const onFocus = () => {
    if (validate) validate(false)
  }

  const onBlur = (event) => {
    if (validate) validate(true)
    if (isDirty) {
      event.target.value = toString(value).substring(0, 1) + event.target.value
      setDirty(false)
    }
  }

  const onChange = (event, { value: newValue }) => {
    setDirty(false)
    if (isNumber) {
      setValue(toFinite(newValue))
    } else {
      setValue(newValue)
    }
  }

  const onKeyDown = (event) => {
    const nextValue = event.target.value.substring(1)
    const isBackSpace = event.keyCode === 8
    const isDeleteFirstDigit = event.target.selectionStart === 1
    const isNotEmpty = !isNil(event.target.value) && nextValue !== ''
    const isDeletingFrontOfComma = !/[1-9.]/.test(event.target.value.substring(1, 2))
    const isNextValueIsNotZero = !(nextValue.startsWith('0.') || nextValue === '0')

    if (isBackSpace && isDeleteFirstDigit && isNotEmpty && isDeletingFrontOfComma && isNextValueIsNotZero) {
      event.preventDefault()
      setDirty(true)
    }
  }

  useEffect(() => {
    const input = document.activeElement
    if (input && !isNil(input.value) && isDirty) {
      input.value = input.value.substring(1)
      if (input.createTextRange) {
        const range = input.createTextRange()
        range.move('character', 0)
        range.select()
      } else if (input.setSelectionRange) {
        input.setSelectionRange(0, 0)
      }
    }
  }, [isDirty])

  const C = (
    <Component
      {...rest}
      value={actualValue}
      type={type}
      setValue={setValue}
      allowNegative={allowNegative}
      customInput={customInput}
      pattern={pattern}
      readOnly={readOnly}
      displayType={displayType}
      thousandSeparator={thousandSeparator}
      validate={validate}
      isNumber={isNumber}
      format={format}
      isAllowed={isAllowed}
      style={style}
      onFocus={onFocus}
      onBlur={onBlur}
      onChange={onChange}
      onKeyDown={onKeyDown}
    />
  )

  if (children || footer) {
    return (
      <Flex column>
        <Flex flex="1 0 100%" justify="space-between">
          {!!children && children}
          {C}
        </Flex>
        {!!footer && footer}
      </Flex>
    )
  }
  return C
}

export default (hoc) => MyComponent
